import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch as useAppDispatch } from 'react-redux';
// material-ui
import { useTheme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { alpha } from '@mui/material/styles';

// third-party
import { FormattedMessage } from 'react-intl';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import Transitions from 'ui-component/extended/Transitions';
import useAuth from 'hooks/useAuth';
import User1 from 'assets/images/users/usericon.png';
import { removeUserWalletList } from 'store/slices/wallet';

// assets
import { IconCash, IconLogout, IconSettings, IconWallet } from '@tabler/icons-react';
import useConfig from 'hooks/useConfig';

// ==============================|| PROFILE MENU ||============================== //

const ProfileBtn = styled(Chip)(({ theme }) => ({
    '.MuiChip-label': { padding: '0px' }
}));

const MenuList = styled(List)(({ theme }) => ({
    '.munulist': {
        ':hover': {
            svg: { stroke: '#fff' },
            p: { color: '#fff' }
        }
    }
}));

const ProfileSection = () => {
    const theme = useTheme();
    const { borderRadius } = useConfig();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { logout, user } = useAuth();
    const [open, setOpen] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(-1);

    /**
     * anchorRef is used on different components and specifying one type leads to other components throwing an error
     * */
    const anchorRef = useRef<any>(null);
    const handleLogout = async () => {
        try {
            dispatch(removeUserWalletList(null));
            await logout();
            navigate('/');
        } catch (err) {
            console.error(err);
        }
    };

    const handleCashinCashout = async () => {
        try {
            navigate('/cashin-cashout');
        } catch (err) {
            console.error(err);
        }
    };

    const handleListItemClick = (event: React.MouseEvent<HTMLDivElement>, index: number, route: string = '') => {
        setSelectedIndex(index);
        // handleClose(event);

        if (route && route !== '') {
            navigate(route);
        }
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event: React.MouseEvent<HTMLDivElement> | MouseEvent | TouchEvent) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };

    const prevOpen = useRef(open);
    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;
    }, [open]);

    // useEffect(() => {
    //     console.log('shafi', user);
    //     debugger;
    // }, [user]);

    return (
        <>
            <ProfileBtn
                sx={{
                    ml: 1,
                    height: '38px',
                    width: '65px',
                    gap: '3px',
                    alignItems: 'center',
                    borderRadius: '0px',
                    transition: 'all .2s ease-in-out',
                    borderColor: alpha(theme.palette.secondary.main, 1),
                    backgroundColor: alpha(theme.palette.secondary.main, 0.55),
                    '&[aria-controls="menu-list-grow"], &:hover': {
                        borderColor: alpha(theme.palette.secondary.main, 0.55),
                        backgroundColor: theme.palette.secondary.main,
                        '& svg': {
                            stroke: theme.palette.primary.light
                        }
                    },
                    '& .MuiChip-label': {
                        lineHeight: 0
                    }
                }}
                icon={
                    <Avatar
                        src={User1}
                        alt="user-images"
                        sx={{
                            ...theme.typography.mediumAvatar,
                            margin: '8px 0 8px 4px !important',
                            cursor: 'pointer',
                            height: '25px',
                            width: '25px'
                        }}
                        ref={anchorRef}
                        aria-controls={open ? 'menu-list-grow' : undefined}
                        aria-haspopup="true"
                        color="inherit"
                        className="4444"
                    />
                }
                label={<IconSettings stroke={1.5} size="24px" color="#fff" />}
                variant="outlined"
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                onClick={handleToggle}
                color="primary"
                aria-label="user-account"
            />

            <Popper
                placement="bottom"
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
                modifiers={[
                    {
                        name: 'offset',
                        options: {
                            offset: [0, 14]
                        }
                    }
                ]}
            >
                {({ TransitionProps }) => (
                    <ClickAwayListener onClickAway={handleClose}>
                        <Transitions in={open} {...TransitionProps}>
                            <Paper>
                                {open && (
                                    <MainCard
                                        className="333222"
                                        sx={{ background: '#050505' }}
                                        border={false}
                                        elevation={16}
                                        content={false}
                                        boxShadow
                                        shadow={theme.shadows[16]}
                                    >
                                        <Box sx={{ p: 2, pb: 0 }}>
                                            <Stack>
                                                <Stack direction="row" spacing={0.5} alignItems="center">
                                                    <Typography variant="h4" sx={{ color: '#fff', fontWeight: '500', fontSize: '14px' }}>
                                                        Welcome
                                                    </Typography>
                                                    <Typography component="span" variant="h4" sx={{ fontWeight: 400, color: '#fff' }}>
                                                        {user?.Username}
                                                    </Typography>
                                                </Stack>
                                            </Stack>
                                        </Box>
                                        <Box sx={{ p: 2, pt: 0 }}>
                                            <MenuList
                                                sx={{
                                                    width: '100%',
                                                    maxWidth: 250,
                                                    minWidth: 200,
                                                    borderRadius: `${borderRadius}px`,
                                                    '& .MuiListItemButton-root': { mt: 0.1 }
                                                }}
                                            >
                                                {/* <ListItemButton
                                                    sx={{
                                                        borderRadius: `${borderRadius}px`,
                                                        backgroundColor: theme.palette.common.white,
                                                        padding: '6px 16px'
                                                    }}
                                                    className="munulist"
                                                    onClick={handleCashinCashout}
                                                >
                                                    <ListItemIcon>
                                                        <IconCash stroke={1.5} size="20px" color="#212121" />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        primary={
                                                            <Typography variant="body2" sx={{ color: '#212121' }}>
                                                                <FormattedMessage id="Cashin/Cashout" />
                                                            </Typography>
                                                        }
                                                    />
                                                </ListItemButton> */}

                                                <ListItemButton
                                                    sx={{
                                                        borderRadius: `${borderRadius}px`,
                                                        backgroundColor: theme.palette.common.white,
                                                        color: '#212121',
                                                        padding: '6px 16px'
                                                    }}
                                                    className="munulist"
                                                    selected={selectedIndex === 0}
                                                    onClick={(event) => handleListItemClick(event, 1, '/transactions')}
                                                    // onClick={(event: React.MouseEvent<HTMLDivElement>) => handleListItemClick(event, 0)}
                                                >
                                                    <ListItemIcon>
                                                        <IconWallet stroke={1.5} size="20px" color="#212121" />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        primary={
                                                            <Typography variant="body2" sx={{ color: '#212121' }}>
                                                                <FormattedMessage id="Transactions" />
                                                            </Typography>
                                                        }
                                                    />
                                                </ListItemButton>

                                                <ListItemButton
                                                    sx={{
                                                        borderRadius: `${borderRadius}px`,
                                                        backgroundColor: theme.palette.common.white,
                                                        padding: '6px 16px'
                                                    }}
                                                    className="munulist"
                                                    onClick={handleLogout}
                                                >
                                                    <ListItemIcon>
                                                        <IconLogout stroke={1.5} size="20px" color="#212121" />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        primary={
                                                            <Typography variant="body2" sx={{ color: '#212121' }}>
                                                                <FormattedMessage id="logout" />
                                                            </Typography>
                                                        }
                                                    />
                                                </ListItemButton>
                                            </MenuList>
                                        </Box>
                                    </MainCard>
                                )}
                            </Paper>
                        </Transitions>
                    </ClickAwayListener>
                )}
            </Popper>
        </>
    );
};
export default ProfileSection;
